import type {RouteRecordRaw} from 'vue-router';
import * as VueRouter from 'vue-router';
import {createRouter, createWebHistory} from 'vue-router';
import JwtService from '@common/services/jwt.service';
import RouteAUTH from '@common/router/routes_auth';
import RouteSYS from '@common/router/routes_sys';
import {useAuthStore} from '@common/store/auth';

import debug from 'debug';

const tracer = debug('vue:router');
tracer('start');

console.log(VueRouter);

const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    scrollBehavior: (to, from, savedPosition) => {
        let scrollTo = 0;

        if (to.hash) {
            const element = document.querySelector(to.hash);
            if (element && element instanceof HTMLElement) {
                scrollTo = element.offsetTop;
            }
        } else if (savedPosition) {
            scrollTo = savedPosition.top ?? 0;
        }

        return {left: 0, top: scrollTo};
    },
    routes: [
        ...RouteAUTH as RouteRecordRaw[],
        ...RouteSYS as RouteRecordRaw[],
    ],
});

router.beforeResolve((to, from, next) => {
    console.log('to', to);
    next();
});

router.beforeEach(async (to, from, next) => {
    const auth: any = useAuthStore();

    if (to.path === '/erreur' || to.path === '/maintenance') {
        next();
        return;
    }

    if(!useAuthStore().estConnecte && to.name !== 'Connexion') {
        tracer('Utilisateur non connecté, redirection vers la page de connexion');
        next({ name: 'Connexion', query: { redirect: to.fullPath } });
        return;
    }

    if(isPagePublique(to.path) || useAuthStore().estConnecte) {
        next();
        return;
    }

    next({
        path: '/erreur',
        query: {
            redirect: to.fullPath
        },
    });


});

function isPagePublique(path: string) {
    const pubPaths = [
        '/auth',
        '/entra-id/login',
        '/erreur',
        '/maintenance',
    ];
    const isPubPath = pubPaths.filter((p) => path.includes(p)).length > 0;
    const startsWithPub = ['/pub/'].filter((p) => path.startsWith(p)).length > 0;

    return isPubPath || startsWithPub
}

export default router;
